import { Box, Link, Typography } from "@mui/material";
import { ToMoneyFormat } from "../../../utils/Helper";
import {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import { ProductWithPriceInvoiceData } from "../../../components/product/ProductWithPrice-v2";
import Input from "../../../components/input/Input-v2";
import React from "react";

export const ReturTableConfig = ({
  onRetuQuantityChange,
  grandTotal,
}: {
  onRetuQuantityChange: (id: string, quantity: number) => void;
  grandTotal: number;
}) => {
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama Produk" },
    { title: "Satuan" },
    { title: "Harga" },
    { title: "Jumlah" },
    { title: "Jumlah Retur" },
    { title: "Total" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "name" },
    { key: "unitType" },
    { key: "price", isMoney: true },
    { key: "quantity" },
    {
      key: "",
      component: (item: ProductWithPriceInvoiceData) => (
        <Input.Text
          type="number"
          label=""
          value={item.returQuantity}
          onChange={(e) => onRetuQuantityChange(item.id, parseInt(e))}
        />
      ),
    },
    {
      key: "",
      component: (item: ProductWithPriceInvoiceData) => (
        <Box width={130}>{ToMoneyFormat(item.price * item.quantity)}</Box>
      ),
    },
  ];
  const lastRow: React.ReactElement[] = [
    <></>,
    <></>,
    <></>,
    <></>,
    <></>,
    <Typography>Grand Total: </Typography>,
    <Typography fontWeight={"bold"}>{ToMoneyFormat(grandTotal)}</Typography>,
  ];

  return { header, body, lastRow };
};

export const EditableQuantityTableConfig = ({
  onQuantityChange,
  grandTotal,
}: {
  onQuantityChange: (id: string, quantity: number) => void;
  grandTotal: number;
}) => {
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama Produk" },
    { title: "Satuan" },
    { title: "Harga" },
    { title: "Jumlah" },
    { title: "Total" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "name" },
    { key: "unitType" },
    { key: "price", isMoney: true },
    {
      key: "",
      component: (item: ProductWithPriceInvoiceData) => (
        <Input.Text
          type="number"
          label=""
          value={item.quantity}
          onChange={(e) => onQuantityChange(item.id, parseInt(e))}
        />
      ),
    },
    {
      key: "",
      component: (item: ProductWithPriceInvoiceData) => (
        <Box width={130}>{ToMoneyFormat(item.price * item.quantity)}</Box>
      ),
    },
  ];
  const lastRow: React.ReactElement[] = [
    <></>,
    <></>,
    <></>,
    <></>,
    <Typography>Grand Total: </Typography>,
    <Typography fontWeight={"bold"}>{ToMoneyFormat(grandTotal)}</Typography>,
  ];

  return { header, body, lastRow };
};

export const NonEditableTableConfig = (grandTotal: number) => {
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nama Produk" },
    { title: "Satuan" },
    { title: "Harga" },
    { title: "Jumlah" },
    { title: "Total" },
  ];
  const body: TableFCBodyProps[] = [
    { key: "name" },
    { key: "unitType" },
    { key: "price", isMoney: true },
    { key: "quantity" },
    {
      key: "",
      component: (item: ProductWithPriceInvoiceData) => {
        return (
          <Box width={130}>{ToMoneyFormat(item.price * item.quantity)}</Box>
        );
      },
    },
  ];
  const lastRow: React.ReactElement[] = [
    <></>,
    <></>,
    <></>,
    <></>,
    <Typography>Grand Total: </Typography>,
    <Typography fontWeight={"bold"}>{ToMoneyFormat(grandTotal)}</Typography>,
  ];

  return { header, body, lastRow };
};

export const ReturTableListConfig = () => {
  const header: TableHeadProps[] = [
    { title: "No" },
    { title: "Nomor Invoice" },
    { title: "Grand Total" },
    { title: "Tanggal" },
  ];
  const body: TableFCBodyProps[] = [
    {
      key: "",
      component: (item) => (
        <Link href={`/invoice/retur/${item.id}`}>
          {item.return_invoice_number}
        </Link>
      ),
    },
    { key: "grand_total", isMoney: true },
    { key: "return_invoice_date", isDate: true },
  ];

  return { header, body };
};
